module.exports = __webpack_public_path__ + "img/1.db034d06.png";